/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Brand } from './Brand';
import {
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface CreatePtwQaEquipmentWithSerialNumberDto
 */
export interface CreatePtwQaEquipmentWithSerialNumberDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {Brand}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    brand1?: Brand;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {SingleDetectorConnectorType}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    singleDetectorConnectorType?: SingleDetectorConnectorType;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePtwQaEquipmentWithSerialNumberDto
     */
    $type?: CreatePtwQaEquipmentWithSerialNumberDtoTypeEnum;
}


/**
 * @export
 */
export const CreatePtwQaEquipmentWithSerialNumberDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreatePtwQaEquipmentWithSerialNumberDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreatePtwQaEquipmentWithSerialNumberDtoTypeEnum = typeof CreatePtwQaEquipmentWithSerialNumberDtoTypeEnum[keyof typeof CreatePtwQaEquipmentWithSerialNumberDtoTypeEnum];



/**
 * Check if a given object implements the CreatePtwQaEquipmentWithSerialNumberDto interface.
 */
export function instanceOfCreatePtwQaEquipmentWithSerialNumberDto(value?: unknown): value is CreatePtwQaEquipmentWithSerialNumberDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreatePtwQaEquipmentWithSerialNumberDtoTypeEnum)[0];
}

export function CreatePtwQaEquipmentWithSerialNumberDtoFromJSON(json: any): CreatePtwQaEquipmentWithSerialNumberDto {
    return CreatePtwQaEquipmentWithSerialNumberDtoFromJSONTyped(json, false);
}

export function CreatePtwQaEquipmentWithSerialNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePtwQaEquipmentWithSerialNumberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'typeNumber': json['typeNumber'] == null ? undefined : json['typeNumber'],
        'brand1': json['brand1'] == null ? undefined : BrandFromJSON(json['brand1']),
        'deviceInterfaceType': json['deviceInterfaceType'] == null ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'defaultImageId': json['defaultImageId'] == null ? undefined : json['defaultImageId'],
        'singleDetectorConnectorType': json['singleDetectorConnectorType'] == null ? undefined : SingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'isRegistrable': json['isRegistrable'] == null ? undefined : json['isRegistrable'],
        'serialNumber': json['serialNumber'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreatePtwQaEquipmentWithSerialNumberDtoToJSON(value?: CreatePtwQaEquipmentWithSerialNumberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isAvailable': value['isAvailable'],
        'imageId': value['imageId'],
        'subCategory': QaEquipmentSubCategoryToJSON(value['subCategory']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'typeNumber': value['typeNumber'],
        'brand1': BrandToJSON(value['brand1']),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value['deviceInterfaceType']),
        'defaultImageId': value['defaultImageId'],
        'singleDetectorConnectorType': SingleDetectorConnectorTypeToJSON(value['singleDetectorConnectorType']),
        'isRegistrable': value['isRegistrable'],
        'serialNumber': value['serialNumber'],
        '$type': value['$type'],
    });
}

